export default __webpack_public_path__ + "static/media/img-25.cc7a2963.jpg";